/**
 * Vendors Domain Menu Provider
 */

import {
  IconPackage,
  IconCalendarEvent,
  IconStar,
  IconSettings,
  IconList,
  IconShoppingCart,
  IconReportAnalytics,
  IconCreditCard,
  IconDashboard,
  IconDatabase,
} from '@tabler/icons-react';
import { DomainMenuProvider, MenuSection } from '../../layouts/menu/types';
import { createVisibilityCheck } from './BaseMenuProvider';
import { useVendorBadgesStore } from '@/domain/badges/vendorBadgesStore';

class VendorsMenuProvider implements DomainMenuProvider {
  domainId = 'vendors';

  getMenuConfig() {
    const sections: MenuSection[] = [
      // Overview Section
      {
        id: 'vendors-overview',
        label: 'Overview',
        items: [
          {
            id: 'vendors-dashboard',
            label: 'Dashboard',
            path: '/app/vendors',
            icon: <IconDashboard size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },

      // Management Section
      {
        id: 'vendors-management',
        label: 'Management',
        items: [
          {
            id: 'vendors-list',
            label: 'Vendors',
            path: '/app/vendors/list',
            icon: <IconList size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
            countSelector: () => useVendorBadgesStore.getState().pendingVendors || null,
            badgeColor: 'orange',
          },
          {
            id: 'vendors-products',
            label: 'Products',
            path: '/app/vendors/products',
            icon: <IconPackage size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
            countSelector: () => useVendorBadgesStore.getState().draftProducts || null,
            badgeColor: 'yellow',
          },
          {
            id: 'vendors-events',
            label: 'Events',
            path: '/app/vendors/events',
            icon: <IconCalendarEvent size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'vendors-ratings',
            label: 'Ratings',
            path: '/app/vendors/ratings',
            icon: <IconStar size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
            countSelector: () => useVendorBadgesStore.getState().pendingRatingResponses || null,
            badgeColor: 'blue',
          },
        ],
      },

      // Operations Section (Coming Soon)
      {
        id: 'vendors-operations',
        label: 'Operations',
        items: [
          {
            id: 'vendors-orders',
            label: 'Orders',
            path: '/app/vendors/orders',
            icon: <IconShoppingCart size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'vendors-payments',
            label: 'Payments',
            path: '/app/vendors/payments',
            icon: <IconCreditCard size={16} />,
            countSelector: () => 'Soon',
            badgeColor: 'green',
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },

      // Insights Section (Coming Soon)
      {
        id: 'vendors-insights',
        label: 'Insights',
        items: [
          {
            id: 'vendors-reports',
            label: 'Reports',
            path: '/app/vendors/reports',
            icon: <IconReportAnalytics size={16} />,
            countSelector: () => 'Soon',
            badgeColor: 'violet',
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },

      // Settings Section
      {
        id: 'vendors-settings',
        label: 'Settings',
        items: [
          {
            id: 'vendors-admin',
            label: 'Admin',
            path: '/app/vendors/admin',
            icon: <IconSettings size={16} />,
            countSelector: () => 'Soon',
            badgeColor: 'orange',
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'vendors-lookups',
            label: 'Lookups',
            path: '/app/vendors/admin/lookups',
            icon: <IconDatabase size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },
    ];

    return {
      domainId: this.domainId,
      sections,
      metadata: {
        version: '1.0.0',
        lastUpdated: Date.now(),
      },
    };
  }
}

export const vendorsMenuProvider = new VendorsMenuProvider();
